import axios from "axios";
import { API_URL } from "../common/config";
import format from "date-fns/format";

const ApiService = {
  init() {
    axios.defaults.baseURL = API_URL;
  },

  query(resource, params) {
    return axios.get(resource, { params }).catch(error => {
      throw new Error(`[News] ApiService ${error}`);
    });
  },

  get(resource, slug = "") {
    return axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`[News] ApiService ${error}`);
    });
  },

  post(resource, params) {
    return axios.post(`${resource}`, params);
  },

  update(resource, slug, params) {
    return axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return axios.put(`${resource}`, params);
  },

  delete(resource) {
    return axios.delete(resource).catch(error => {
      throw new Error(`[News] ApiService ${error}`);
    });
  }
};

export default ApiService;

export const NewsService = {
  getTopXForHomePage(limit) {
    return ApiService.get("Posts/GetForHomePageWeb", limit);
  },
  getHighlighted(skip, take) {
    return ApiService.query("Posts/GetHighlighted", { Skip: skip, Take: take, IncludeContent: false });
  },
  getMostRead(categoryId, subcategoryId, skip, take, daysInterval) {
    return ApiService.query("Posts/GetMostRead", { Skip: skip, Take: take, CategoryID: categoryId, SubcategoryID: subcategoryId, DaysInterval: daysInterval, IncludeContent: false });
  },
  getMostRecent(categoryId, subcategoryId, skip, take) {
    return ApiService.query("Posts/GetMostRecent", { CategoryID: categoryId, SubcategoryID: subcategoryId, Skip: skip, Take: take, IncludeContent: false});
  },
  getPopular(take, daysInterval, categoryID) {
    return ApiService.query("Posts/GetPopular", { Take: take, DaysInterval: daysInterval, CategoryID: categoryID });
  },
  getPostsMain(take, highlighted, categoryID) {
    return ApiService.query("Posts/GetPostsMain", { Take: take, Highlighted: highlighted, CategoryID: categoryID });
  },
  getVideoBoxInfo(skip, take) {
    return ApiService.query("Posts/GetVideoPosts", { Skip: skip, Take: take });
  },
  getPhotoPosts(skip, take) {
    return ApiService.query("Posts/GetPhotoPosts", { Skip: skip, Take: take});
  },
  search(text, categoryID, subCategoryID, tagID, skip, take, hasMultimedia, categorySearchCode, subcategorySearchCode) {
    return ApiService.query("Search", { Text: text, CategoryId: categoryID, SubCategoryId: subCategoryID, TagID: tagID, Skip: skip, Take: take, HasMultimedia: hasMultimedia, CategorySearchCode: categorySearchCode, SubcategorySearchCode: subcategorySearchCode });
  },
  details(id) {
    return ApiService.get("Posts/GetDetails", id);
  }
};

export const CategoriesService = {
    get() {
        return ApiService.get("PostCategories/Get");
    },
    getAllPostCategories() {
        return ApiService.get("PostCategories/GetAllPostCategories");
    },
    getPopular(take = 10, daysFrom = 30) {
        return ApiService.query("PostCategories/GetPopularCategories", { take, daysFrom })
    }
};

export const AboutService = {
    getAboutInfo() {
        return ApiService.get("About/GetAboutInfo");
    },
    getContactInfo() {
        return ApiService.get("About/GetContactInfo");
    },
    getMarketingInfo() {
        return ApiService.get("About/GetMarketingInfo");
    },
    getSocialNetworksInfo() {
        return ApiService.get("About/GetSocialNetworksInfo");
    }
};

export const PollService = {
    getActivePoll(userIpAddress) {
        return ApiService.query("Poll/GetActivePoll", { userIpAddress });
    },
    vote(pollID, pollAnswerID, userIpAddress) {
        return ApiService.post("Poll/Vote", { PollID: pollID, PollAnswerID: pollAnswerID, UserIpAddress: userIpAddress});
    }
};
 
export const TagsService = {
    getActiveTagsSideBar() {
        return ApiService.get("Tags/GetActiveTagsSideBar");
    },
    getById(tagId) {
      return ApiService.query("Tags/GetById", { tagId });
    }
};

export const AdvertisementsService = {
    getActive() {
        return ApiService.get("Advertisements/GetActive");
    },
    updateImpressions(updateImpressionsForAdIds) {
        return ApiService.post("Advertisements/UpdateImpressions", { UpdateImpressionsForAdIds: updateImpressionsForAdIds });
    },
    updateClicks(advertisementID) {
        return ApiService.post("Advertisements/UpdateClicks", { AdvertisementID: advertisementID });
    }
};

export const IpAddressService = {
    get() {
        return ApiService.query("https://api.ipify.org/?format=json");
    }
};

export const ExchangeRatesService = {
  getTodaysExchangeRates() {
      return ApiService.get("ExchangeRates/GetTodaysExchangeRates");
  },
  currencyConverter(amount, from, to, course) {
     return ApiService.post("ExchangeRates/CurrencyConverter", { Amount: amount.toString(), From: from.toString(), To: to.toString(), Course: course});
  }
};



// WEBPACK FOOTER //
// ./src/common/api.service.js